import apiClient from './client'
import type { Auxiliar, CreateAuxiliarRequest, UpdateAuxiliarRequest, PaginatedResponse } from '@/types/auxiliar'

export const auxiliaresApi = {
    getAll: (params?: { search?: string; page?: number; pageSize?: number }) =>
        apiClient.get<PaginatedResponse<Auxiliar>>('/auxiliares', { params }).then((r) => r.data),

    getById: (id: string) =>
        apiClient.get<Auxiliar>(`/auxiliares/${id}`).then((r) => r.data),

    create: (data: CreateAuxiliarRequest) =>
        apiClient.post<Auxiliar>('/auxiliares', data).then((r) => r.data),

    update: (id: string, data: UpdateAuxiliarRequest) =>
        apiClient.put<Auxiliar>(`/auxiliares/${id}`, data).then((r) => r.data),

    delete: (id: string) =>
        apiClient.delete(`/auxiliares/${id}`),

    getByTipo: (idTipoAuxiliar: string) =>
        apiClient.get<{ idAuxiliar: string; descripcion: string | null }[]>(`/auxiliares/tipo/${idTipoAuxiliar}`).then((r) => r.data),
}
